export default __webpack_public_path__ + "static/productIdentification-520e94467f28a7ba1ba267613fb1b63d.png";